module.exports = __webpack_public_path__ + "img/img_innovation5.7a6ebd37.png";